export const Payment_thank_you_svg = () => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 1920 1920"
      width="400"
      height="400"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path transform="translate(0)" d="m0 0h1920v1920h-1920z" fill="#FDFDFD" />
      <path
        transform="translate(455,538)"
        d="m0 0h471l18 4 16 7 13 10 10 10 9 14 5 12 3 15v524h515l10 4 9 9 4 9 1 4v397l-3 9-5 8h19l3 3v6l-4 4h-1246l-3-3v-8l2-2h130v-2l-5-2-10-7-10-9-9-10-10-17-5-14-2-11v-892l4-18 8-16 12-15 13-10 14-7 16-5z"
        fill="#2F348F"
      />
      <path
        transform="translate(928,333)"
        d="m0 0h64l33 2 35 4 44 7 44 10 35 10 33 11 26 10 30 13 25 12 29 15 22 13 19 12 18 12 14 10 32 24 13 11 10 9 8 7 10 9 15 14 18 18 7 8 13 14 7 8v2h2l7 9 12 15v2h2l14 19 13 19 14 21 15 25 10 18 11 20 13 28 10 23 11 28 12 36 8 27 10 42 5 27 5 32 3 30 2 33v65l-3 41-3 28-6 38-9 41-10 36-12 37-14 36-10 23-15 30-13 25-8 14-12 19-22 33-13 18-13 16-8 10-3 2 1-7v-397l-4-11-7-8-8-5-4-1-515-1-1-524-3-15-7-16-9-12-9-9-13-9-14-6-18-4h-471l-14 2 14-14 8-7 10-9 5-4h2v-2l17-13 18-14 17-12 18-12 22-14 26-15 35-18 19-9 31-13 35-13 39-12 36-9 34-7 49-7 32-3z"
        fill="#AEDDD8"
      />
      <path
        transform="translate(491,587)"
        d="m0 0h16l12 1 8 14 13 21 7 13v2l5 2 2 1h273l5-3 5-8 9-16 12-19 5-8h28l16 4 12 6 13 12 7 10 5 12 2 10v493l-103 1-12 6-4 3v-29l-3-19-6-20-8-17-10-15-11-13-11-10-15-11-23-11-16-5-16-3-19-1-22 2-17 4-16 6-15 8-14 10-12 11-10 11-11 17-9 19-5 17-3 18v27l3 17 5 17 8 18 10 16 12 14 12 11 15 10 17 9 21 7 16 3h31l14-2 15-4 15-6 15-8 11-8 13-11 9-10 12-18 10-21h1v349h-327l-14-4-12-7-9-7-8-8-9-14-5-14-1-4v-826l4-14 6-11 9-10 7-6 8-5 15-5z"
        fill="#8FCB8D"
      />
      <path
        transform="translate(455,538)"
        d="m0 0h471l18 4 16 7 13 10 10 10 9 14 5 12 3 15v524h515l10 4 9 9 4 9 1 4v397l-3 9-5 8h19l3 3v6l-4 4h-1246l-3-3v-8l2-2h130v-2l-5-2-10-7-10-9-9-10-10-17-5-14-2-11v-892l4-18 8-16 12-15 13-10 14-7 16-5zm36 49-14 3-10 4-11 8-9 9-8 14-4 14v826l5 16 8 13 9 10 7 6 13 8 11 4 5 1h327v-349l-2 2-10 21-12 17-12 13-14 11-15 9-15 7-17 5-9 2-9 1h-31l-20-4-19-7-17-9-14-10-13-12-10-12-10-16-8-18-5-17-3-17v-27l3-18 5-17 10-21 11-16 11-12 11-10 15-10 16-8 13-5 17-4 22-2 19 1 20 4 17 6 21 11 14 11 13 12 10 13 9 15 7 16 5 17 3 19v29l9-6 7-3 103-1v-493l-4-16-6-11-9-10-10-8-10-5-16-4h-28l-12 19-9 15-9 16-3 3-3 1h-273l-5-3h-2l-2-5-6-12-15-24-5-9-12-1zm357 558-9 4-5 6-3 8v387l2 10 5 7 8 5h667l8-5 5-6 2-9v-386l-2-9-7-8-6-3-12-1z"
        fill="#323232"
      />
      <path
        transform="translate(381,605)"
        d="m0 0h1v897l3 14 5 13 9 15 14 15 12 9 7 4v2h-129v-1l85-1-11-13-13-17-8-10-13-18-19-29-10-16-13-23-15-28-9-20-7-15-14-34-14-41-12-43-9-41-7-45-4-45-1-17v-65l2-33 4-37 7-42 8-36 10-37 12-37 11-28 11-26 12-26 12-22 8-15 13-22 12-19 15-22 12-16 7-10h2l2-5z"
        fill="#AFDDD8"
      />
      <path
        transform="translate(455,550)"
        d="m0 0h471l15 4 10 4 10 7 10 9 9 13 5 12 3 14v521h-29l-1-1-1-497-3-12-8-16-11-13-12-9-13-6-11-3-9-1h-28l-7 3-7 10-12 20-10 17-2 4h-267l-9-17-13-21-8-12-4-3-3-1h-29l-17 3-12 5-11 7-3 1-2 4-8 8-8 13-5 15-2 16v811l3 16 6 15 8 12 9 10 9 8 11 7 16 6 4 1 330 1 1 1 1 23 4 10 1 2h-363l-15-4-16-8-11-8-10-10-9-13-6-13-3-13v-891l4-16 8-15 11-12 11-8 13-6z"
        fill="#C7C7C9"
      />
      <path
        transform="translate(121,1573)"
        d="m0 0h104l4 4v3h70l1-3 1 7 2 2h1246l3-3 1-3h73l2-5 2-2h169l4 4v6l-5 5-4 6-10 8-16 7-22 6-27 4-23 2h-139l-58-1h-51l-66 2-75 4-138 10-109 6-78 3-50 1h-54l-43-1-56-3-55-5-39-6-42-8-29-4-22-2h-49l-32 3-48 7-33 5-18 2-18 1h-16l-26-2-28-5-43-11-49-12-53-12-25-5-33-1-4-4v-6z"
        fill="#CACACA"
      />
      <path
        transform="translate(1501,1159)"
        d="m0 0h26l1 7v386l-2 9-7 8-6 3h-667l-2-2 1-20 635-1 10-4 8-9 2-7v-250h-655v-68h655z"
        fill="#2E2D78"
      />
      <path
        transform="translate(848,1145)"
        d="m0 0h653l12 1 6 3 7 8v2h-25v52l-1 1h-654l-1 358-5-2-5-5-3-6-1-7v-387l4-10 7-6z"
        fill="#2F3490"
      />
      <path
        transform="translate(455,550)"
        d="m0 0h471l15 4 10 4 10 7 5 4v2l-6-1-12-3-12-1h-448l-16 1-14 4-12 5-14 10-7 7-10 15-6 17-1 7v891l1 10-5-2-8-16-3-13v-891l4-16 8-15 11-12 11-8 13-6z"
        fill="#DFDFDF"
      />
      <path
        transform="translate(856,1325)"
        d="m0 0h430l1 2-1 32h-430l-1-1v-32z"
        fill="#46489D"
      />
      <path
        transform="translate(848,1145)"
        d="m0 0h653l12 1 6 3 6 6v3l-661 1-9 4-7 8-3 8-1 391-7-4-4-6-2-10v-387l4-10 7-6z"
        fill="#8282BE"
      />
      <path
        transform="translate(856,1455)"
        d="m0 0h344v34h-344l-1-1v-32z"
        fill="#46489D"
      />
      <path
        transform="translate(856,1405)"
        d="m0 0h344v33l-1 1h-343l-1-1v-32z"
        fill="#46489D"
      />
      <path
        transform="translate(491,587)"
        d="m0 0h16l3 3 2 6-16 3-11 4-10 6-10 8-8 11-6 12-3 11-1 7v616l1 207 5 16 1 2-4-2-9-14-5-14-1-4v-826l4-14 6-11 9-10 7-6 8-5 15-5z"
        fill="#B6DCB5"
      />
      <path
        transform="translate(968,572)"
        d="m0 0 5 5 7 10 5 12 3 14v521h-29v-1h9l-1-560z"
        fill="#A2A2A3"
      />
      <path
        transform="translate(407,1534)"
        d="m0 0 6 1 12 5 16 3 378 1v-8h1l1 23 4 10 1 2h-363l-15-4-16-8-11-8-10-10z"
        fill="#A2A2A3"
      />
      <path
        transform="translate(767,1061)"
        d="m0 0h9l8 5 5 6 1 3v8l-6 8-14 12-10 9-11 9-10 9-11 9-11 10-11 9-14 13-11 9-9 8-5 3-10 1-8-4-10-12-14-19-14-18-9-12-10-14-1-6 3-9 8-7 3-1h7l8 4 8 9 15 20 10 13 9 12 5-2 12-11 11-9 12-11 8-7 11-9 12-11 11-9 12-11 9-6z"
        fill="#8FCB8D"
      />
      <path
        transform="translate(819,1174)"
        d="m0 0h1v349h-327l-14-4-12-7-4-4 7 1 349 1-1-334z"
        fill="#7FB480"
      />
      <path
        transform="translate(642,577)"
        d="m0 0h143l5 3 3 5 1 9-3 7-4 4-3 1h-141l-6-3-4-8v-7l3-7z"
        fill="#323232"
      />
      <path
        transform="translate(863,587)"
        d="m0 0h28l16 4 8 4 1 2h-37l-5 5-11 18-13 22-5 8-2 1-81 1h-120l-78-1-8-3-5-5v-2h276l5-3 5-8 9-16 12-19z"
        fill="#B2D8B2"
      />
      <path
        transform="translate(945,803)"
        d="m0 0h1v189l-12 17-4 6-2-1v-186l4-7 12-17z"
        fill="#6AA76B"
      />
      <path
        transform="translate(923,601)"
        d="m0 0 7 6 6 7 7 14 3 13v162l-11 15-5 7h-1l-1-197-2-14-3-10z"
        fill="#7EB37F"
      />
      <path
        transform="translate(1347,1474)"
        d="m0 0h8l10 3 8 6 5 6 4 11v11l-3 9-4 6-7 6-10 4h-15l-10-5-6-5-6-12-1-4v-9l3-10 6-8 5-4 8-4z"
        fill="#323232"
      />
      <path
        transform="translate(1395,1475)"
        d="m0 0h15l12 6 7 8 4 10v13l-4 9-5 7-11 7-5 1h-11l-10-3-10-9 1-4 3-9v-11l-4-11 2-4 8-7z"
        fill="#B6DCB5"
      />
      <path
        transform="translate(1630,1573)"
        d="m0 0h169l4 4v6l-4 4h-169l-4-5 1-6z"
        fill="#37373B"
      />
      <path
        transform="translate(945,992)"
        d="m0 0h1v142h-99v-1h82l-1-119 5-5z"
        fill="#7EB37F"
      />
      <path
        transform="translate(819,1174)"
        d="m0 0h1v349h-118l2-5 6-8h109l-1-334z"
        fill="#6CA86D"
      />
      <path
        transform="translate(136,1341)"
        d="m0 0h12l8 4 6 7 3 7v12l-5 10-8 7-3 1h-14l-8-5-5-6-3-8v-10l4-10 7-6z"
        fill="#B0DED8"
      />
      <path
        transform="translate(121,1573)"
        d="m0 0h104l4 4v6l-4 4h-104l-4-4v-6z"
        fill="#37373B"
      />
      <path
        transform="translate(463,1508)"
        d="m0 0 7 1 112 1-7 12-1 1h-81l-14-4-12-7z"
        fill="#6AA76B"
      />
      <path
        transform="translate(1745,1296)"
        d="m0 0 8 1 8 6 3 1 11-7h7l1 1v6l-5 10-2 2 1 4 5 10 1 6-1 2-9-1-8-6h-4l-9 6-6 1-3-2 1-8 7-10-2-5-5-10v-6z"
        fill="#B0DED8"
      />
      <path
        transform="translate(1779,1179)"
        d="m0 0 10 1 6 4 5 7 1 4v8l-4 9-5 4-4 2h-12l-6-4-4-5-2-5v-11l3-6 5-5z"
        fill="#B0DED8"
      />
      <path
        transform="translate(337,386)"
        d="m0 0h8l8 4 5 6 2 7-1 9-3 6-7 6-3 1h-10l-6-3-6-7-1-3v-12l4-8 5-4z"
        fill="#B0DED8"
      />
      <path
        transform="translate(136,1182)"
        d="m0 0 11 2 8 9 1 3v11l-4 8-6 5-2 1h-12l-7-4-4-5-2-6v-8l3-8 7-6z"
        fill="#B0DED8"
      />
      <path
        transform="translate(1671,566)"
        d="m0 0h11l8 5 4 6 1 3v10l-3 7-8 7h-14l-6-4-4-5-2-5v-10l4-8 6-5z"
        fill="#B0DED8"
      />
      <path
        transform="translate(1568,390)"
        d="m0 0h10l6 3 6 7 1 3v13l-5 8-6 4-3 1h-7l-7-3-5-5-3-5v-13l4-8 6-4z"
        fill="#B0DED8"
      />
      <path
        transform="translate(244,494)"
        d="m0 0 5 1 3 7 1 10 10 1 6 3 1 5-6 4-11 2-1 10-3 6-5 1-3-4-2-7v-6l-11-2-6-4 1-5 9-4 6-1 3-13z"
        fill="#B1DED8"
      />
      <path
        transform="translate(665,833)"
        d="m0 0h7l11 18 3-3 9-15h7v33l-7 1-1-1-1-15-7 12h-5l-7-11-1 14-1 1h-7z"
        fill="#323232"
      />
      <path
        transform="translate(741,833)"
        d="m0 0h7l12 14v2h2v2h2v-18h8v33h-8l-11-13-3-4-1 17h-8z"
        fill="#323232"
      />
      <path
        transform="translate(567,833)"
        d="m0 0h19l6 3 4 5v8l-4 6-4 2h-13v9h-8z"
        fill="#323232"
      />
      <path
        transform="translate(596,577)"
        d="m0 0h12l6 5 2 5v9l-3 6-7 4h-9l-5-3-4-5v-13l6-7z"
        fill="#323232"
      />
      <path
        transform="translate(610,833)"
        d="m0 0h8l14 31v2l-8 1-3-6h-15l-2 5h-9l5-13 8-18z"
        fill="#323232"
      />
      <path
        transform="translate(710,833)"
        d="m0 0h25v7h-17v6h15v7h-15v7h17v6l-7 1h-18l-1-1v-32z"
        fill="#323232"
      />
      <path
        transform="translate(668,889)"
        d="m0 0h25l1 1v6l-17 1v5l15 1v6l-15 1-1 6h18v7h-26z"
        fill="#323232"
      />
      <path
        transform="translate(563,889)"
        d="m0 0h7l1 1 1 22 2 3h8l2-4 1-21 1-1h7v25l-4 6-4 3-10 1-7-3-4-4-2-10v-17z"
        fill="#323232"
      />
      <path
        transform="translate(790,889)"
        d="m0 0h7l1 1 1 22 2 3h7l2-1 1-3 1-22h7l1 1v22l-3 7-6 4-9 1-8-3-4-6z"
        fill="#323232"
      />
      <path
        transform="translate(706,889)"
        d="m0 0h12l6 3-2 6-5-1h-9v4l13 4 4 4v8l-5 5-6 2-11-1-6-3 2-6h3l6 2h6l2-1v-3l-15-5-3-4v-7l4-5z"
        fill="#323232"
      />
      <path
        transform="translate(736,889)"
        d="m0 0h12l6 3-2 6-5-1h-9v4l13 4 4 4v8l-5 5-6 2-11-1-6-3 2-6 9 2h6l2-1v-3l-13-4-5-5v-7l4-5z"
        fill="#323232"
      />
      <path
        transform="translate(540,889)"
        d="m0 0h11l6 3-2 6-5-1h-9l-1 3 14 5 4 4v8l-5 5-6 2-11-1-5-3 1-6 6 1 9 1 2-1v-3l-13-4-5-5v-7l4-5z"
        fill="#323232"
      />
      <path
        transform="translate(644,889)"
        d="m0 0h12l8 5-5 6-6-3h-6l-5 4-1 2v6l3 5 2 1h8l3-2 4 1 3 4-5 4-6 2-10-1-7-4-4-7v-11l3-6 5-4z"
        fill="#323232"
      />
      <path
        transform="translate(611,889)"
        d="m0 0h11l8 5-2 4-4 2-4-3h-7l-5 5-1 6 3 6 2 1h9l5-2 4 5-5 4-6 2-10-1-6-4-4-5-1-3v-9l3-7 5-4z"
        fill="#323232"
      />
      <path
        transform="translate(760,889)"
        d="m0 0h25v7h-17v8h15v7h-15v12h-8z"
        fill="#323232"
      />
      <path
        transform="translate(629,833)"
        d="m0 0h9l8 13 8-13h8l-2 5-9 16-1 12-1 1h-7l-1-1-1-12-9-16z"
        fill="#323232"
      />
      <path
        transform="translate(514,596)"
        d="m0 0h9l11 17 10 17 3 6-1 2-5-2-8-5v-2h-2l-7-11-8-16-2-3z"
        fill="#6AA76B"
      />
      <path
        transform="translate(775,833)"
        d="m0 0h29l1 1v5l-1 1h-10v26h-8v-26h-11z"
        fill="#323232"
      />
      <path
        transform="translate(827,889)"
        d="m0 0h8v27h16l1 1v6h-25z"
        fill="#323232"
      />
      <path
        transform="translate(575,840)"
        d="m0 0h10l2 2v7l-3 2h-8l-1-1z"
        fill="#8CC88A"
      />
      <path
        transform="translate(509,588)"
        d="m0 0h10l4 8h-9l-4-4z"
        fill="#80B583"
      />
      <path
        transform="translate(613,842)"
        d="m0 0 2 2 3 9h-9l3-9z"
        fill="#89C588"
      />
    </svg>
  );
};
